// extracted by mini-css-extract-plugin
module.exports = {"ButtonContent":"BackNavigation_ButtonContent__LIh2r","BackLabel":"BackNavigation_BackLabel__17rqY"};